import EmptyList from 'components/empty-list/EmptyList';
import Link from 'components/link/Link';
import Vacancy from 'components/vacancy/Vacancy';

import { IVacancies } from 'source/NFR.types';

const Vacancies: React.FC<IVacancies> = ({ emptyList, items = [], link, title, text }) => (
  <div className="vacancies">
    {title && <h2 className="vacancies--title">{title}</h2>}
    {items.length > 0 ? (
      items.map(event => <Vacancy key={event.id} headingLevel={3} {...event} />)
    ) : (
      <EmptyList {...emptyList} />
    )}
    <div className="vacancies--cta">
      <p>{text}</p>
      <Link theme="primary" useButtonStyles {...link} />
    </div>
  </div>
);

Vacancies.displayName = 'Vacancies';

export default Vacancies;
